import * as types from './actionTypes';

export function awardsSet(awards: any | null) {
  return { type: types.BUYER_AWARDS_SET, awards };
}

export function awardsClosedSet(awardsClosed: any | null) {
  return { type: types.BUYER_AWARDS_CLOSED_SET, awardsClosed };
}
